import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, CartesianGrid } from 'recharts';


interface ChartProps {
  data?: any[];
}

export default function Chart( { data }: ChartProps) {
  const theme = useTheme();

  return (
    <React.Fragment>
      <ResponsiveContainer >
        <LineChart
          data={data}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 0,
          }}
        >
          <XAxis
            dataKey="key"
            stroke='gray'
            tickLine={false}
            strokeDasharray="3 3"
          />
          <YAxis
            stroke='gray'
            tickLine={false}
            axisLine={false}
          />
          <CartesianGrid stroke={theme.palette.shadow.dark} strokeDasharray="3 3" vertical={false} />
          <Line
            isAnimationActive={false}
            type="monotone"
            dataKey="value"
            stroke={theme.palette.secondary.light}
            strokeWidth={5}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}